import { Card, Tab, Tabs } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import AddStationaryEnergyStorage from "./AddStationaryEnergyStorage";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import AddStationaryEventGallery from "./addStationaryEventGallery";
import HelperService from "../../utility/HelperService";
const StationaryEnergyStorage = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [data, setData] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);
  const [showEventModal, setShowEventModal] = useState(false);
  const [editingEvent, setEditingEvent] = useState<any>(null);
  const [eventMode, setEventMode] = useState<"add" | "edit">("add");
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    WebService.getAPI({
      action: `council/getContent?type=STATIONARY_ENERGY`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
        //  toast.error(err.response?.data?.message || "An error occurred");
      });
  };
  const reorderEvents = (fromIndex: number, toIndex: number) => {
    if (fromIndex === toIndex) return;

    const updatedEvents = [...data.events];
    const [moved] = updatedEvents.splice(fromIndex, 1);
    updatedEvents.splice(toIndex, 0, moved);

    const body = new FormData();
    body.append("events", JSON.stringify(updatedEvents));
    body.append("id", data._id);

    WebService.fileUploadAPI({
      action: `council/addEvents`,
      body,
    })
      .then(() => {
        getData();
      })
      .catch(() => {
        toast.error("Failed to reorder events");
      });
  };
  return (
    <>
      <AddStationaryEnergyStorage
        show={showAddModal}
        handleClose={() => {
          setShowAddModal(false);
          getData();
        }}
        data={data}
      />
      <AddStationaryEventGallery
        show={showEventModal}
        handleClose={() => {
          setShowEventModal(false);
          getData();
        }}
        data={data}
        event={editingEvent}
        mode={eventMode}
      />
      <div className="events-main">
        <Card className="event-card">
          <div>
            <Tabs defaultActiveKey="info" className="mt-3">
              <Tab eventKey="info" title="Info" className="p-3">
                {isLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: 100 }}
                  >
                    <span
                      className="spinner-border"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="page-title">
                        Stationary Energy Storage India Council
                      </div>
                      {pagePermission.canAdd && (
                        <CustomButton
                          className="mt-2"
                          isLoading={false}
                          label={data ? "Edit" : "Add"}
                          onClick={() => {
                            setShowAddModal(true);
                          }}
                          style={{ width: 100 }}
                        />
                      )}
                    </div>
                    {data?.logo && (
                      <div className="mb-2 mt-2">
                        <img
                          src={data.logo}
                          alt="Event"
                          style={{
                            objectFit: "contain",

                            height: "auto",
                          }}
                        />
                      </div>
                    )}

                    <div className="mb-3">
                    <strong>Title</strong>
                    {data?.title && <div>{data.title}</div>}
                    </div>

                    <strong>Description</strong>
                    {data?.description && (
                      <div className="ql-snow">
                        <div
                          className="mt-2 px-0 ql-editor"
                          dangerouslySetInnerHTML={{ __html: HelperService.getPreviewableHTML(data.description) }}
                        />
                      </div>
                    )}
                    {data?.trust_areas && data.trust_areas.length > 0 && (
                      <>
                        <h5 className="mt-4 mb-3">Thrust Areas</h5>

                        <div className="d-flex flex-wrap gap-3">
                          {data.trust_areas.map(
                            (trustarea: any, index: number) => (
                              <div
                                key={trustarea._id || index}
                                className="border rounded-3 p-3 d-flex flex-column align-items-center"
                                style={{ width: 220 }}
                              >
                                {/* LOGO */}
                                {trustarea.logo && (
                                  <img
                                    src={trustarea.logo}
                                    alt={
                                      trustarea.title || `Key Area ${index + 1}`
                                    }
                                    style={{
                                      width: 160,
                                      height: 120,
                                      objectFit: "contain",
                                    }}
                                    className="mb-2"
                                  />
                                )}

                                {/* TITLE */}
                                {trustarea.title && (
                                  <div className="text-center fw-semibold">
                                    {trustarea.title}
                                  </div>
                                )}
                              </div>
                            )
                          )}
                        </div>
                      </>
                    )}
                    {data?.stackholders && data.stackholders.length > 0 && (
                      <>
                        <h5 className="mt-4 mb-3">Key Stackholders</h5>

                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fill, minmax(220px, 1fr))",
                            gap: 20,
                          }}
                        >
                          {data.stackholders.map((item: any, index: number) => (
                            <div
                              key={index}
                              style={{
                                background: "#ffffff",
                                borderRadius: 14,
                                padding: "18px 14px",
                                textAlign: "center",
                                fontSize: 14,
                                fontWeight: 500,
                                color: "#000",
                                border: "1px solid #dff1ff",
                                boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
                                cursor: "default",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform =
                                  "translateY(-3px)";
                                e.currentTarget.style.boxShadow =
                                  "0 10px 22px rgba(0,0,0,0.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform =
                                  "translateY(0)";
                                e.currentTarget.style.boxShadow =
                                  "0 6px 16px rgba(0,0,0,0.06)";
                              }}
                            >
                              {item.title}
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                    {data?.events && data.events.length > 0 && (
                      <>
                        <h5 className="mt-4 mb-3">Event Gallery</h5>

                        <div className="d-flex flex-wrap gap-3">
                          {data.events.map((event: any, index: number) => (
                            <div
                              key={event._id || index}
                              className="border rounded-3 p-3"
                              style={{ width: 240 }}
                            >
                              {/* EVENT IMAGES */}
                              {event.images && event.images.length > 0 && (
                                <div className="d-flex flex-wrap justify-content-center gap-2 mb-2">
                                  {event.images.map(
                                    (img: any, imgIndex: number) => (
                                      <img
                                        key={imgIndex}
                                        src={img.image}
                                        alt={`Event ${index + 1} - ${imgIndex + 1
                                          }`}
                                        style={{
                                          width: 90,
                                          height: 70,
                                          objectFit: "cover",
                                          borderRadius: 6,
                                        }}
                                      />
                                    )
                                  )}
                                </div>
                              )}

                              {/* TITLE */}
                              {event.title && (
                                <div className="text-center fw-semibold mt-1">
                                  {event.title}
                                </div>
                              )}

                              {/* DATE */}
                              {event.publishDate && (
                                <div className="text-center text-muted small">
                                  {event.publishDate}
                                </div>
                              )}

                              {/* LOCATION */}
                              {event.location && (
                                <div className="text-center text-muted small">
                                  {event.location}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </>
                )}
              </Tab>
              <Tab eventKey="events" title="Event Gallery">
                <div className="p-3">
                  {/* ADD BUTTON */}
                  <div className="d-flex justify-content-end mb-3">
                    {pagePermission.canEdit && (
                      <CustomButton
                        label="Add Event Gallery"
                        isLoading={false}
                        onClick={() => {
                          setEventMode("add");
                          setEditingEvent(null);
                          setShowEventModal(true);
                        }}
                        style={{ width: 200 }}
                      />
                    )}
                  </div>

                  {/* NO EVENTS */}
                  {(!data?.events || data.events.length === 0) && (
                    <div>No event gallery found</div>
                  )}

                  {/* EVENTS LIST */}
                  {data?.events && data.events.length > 0 && (
                    <div className="d-flex flex-wrap gap-3">
                      {data.events.map((event: any, index: number) => (
                        <div
                          key={index}
                          draggable
                          onDragStart={(e) =>
                            e.dataTransfer.setData(
                              "eventIndex",
                              index.toString()
                            )
                          }
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            const fromIndex = Number(
                              e.dataTransfer.getData("eventIndex")
                            );
                            reorderEvents(fromIndex, index);
                          }}
                          className="border rounded p-3 bg-light"
                          style={{
                            width: 320,
                            cursor: "move",
                            background: "#fff",
                          }}
                        >
                          {/* DRAG HANDLE */}
                          <div
                            style={{
                              cursor: "grab",
                              color: "#888",
                              marginBottom: 6,
                            }}
                            title="Drag to reorder"
                          >
                            ☰
                          </div>

                          {/* IMAGE */}
                          {event.images &&
                            event.images.length > 0 &&
                            event.images[0]?.image && (
                              <img
                                src={event.images[0].image}
                                alt={event.title}
                                style={{
                                  width: "100%",
                                  height: 140,
                                  objectFit: "contain",
                                  borderRadius: 6,
                                }}
                                className="mb-2"
                              />
                            )}

                          <strong>{event.title}</strong>
                          <div
                            className="text-muted mt-1"
                            style={{ fontSize: 13 }}
                          >
                            {event.description}
                          </div>

                          {/* ACTIONS */}
                          <div className="d-flex gap-2 mt-2">
                            <PencilFill
                              className="cursor-pointer"
                              onClick={() => {
                                setEventMode("edit");
                                setEditingEvent({ ...event, index });
                                setShowEventModal(true);
                              }}
                            />
                            <TrashFill
                              color="#DC143C"
                              className="cursor-pointer"
                              onClick={() => {
                                setDeleteIndex(index);
                                setShowDeleteModal(true);
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Tab>
            </Tabs>
          </div>
        </Card>
        {showDeleteModal && (
          <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                  />
                </div>

                <div className="modal-body">
                  Are you sure you want to delete this event gallery?
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    No
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      if (deleteIndex === null) return;

                      const updated = data.events.filter(
                        (_: any, i: number) => i !== deleteIndex
                      );

                      const body = new FormData();
                      body.append("events", JSON.stringify(updated));
                      body.append("id", data._id);

                      WebService.fileUploadAPI({
                        action: `council/addEvents`,
                        body,
                      }).then(() => {
                        toast.success("Event deleted");
                        setShowDeleteModal(false);
                        setDeleteIndex(null);
                        getData();
                      });
                    }}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default StationaryEnergyStorage;
